<script setup lang="ts">
const benefits = [
  {
    title: 'Bisa Pick Up di Lokasimu',
    description:
      'Hemat tenaga untuk antar paket besar, kurir akan jemput paket ke lokasimu.',
    icon: 'material-symbols:package-2-outline',
    iconSize: '33px'
  },
  {
    title: 'Bisa COD dan Non COD',
    description:
      'Pilihan metode pembayaran fleksibel untuk memenuhi permintaan pelanggan.',
    icon: 'material-symbols:account-balance-wallet-outline',
    iconSize: '33px'
  },
  {
    title: 'Ongkir Lebih Hemat',
    description: 'Kirim paket besar lebih efisien dengan harga terjangkau.',
    icon: 'ic:outline-discount',
    iconSize: '33px'
  }
]
</script>

<template>
  <section class="bg-surface-container-low">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <h2
        class="text-2xl leading-7 lg:text-4xl font-bold lg:text-center text-on-secondary-container font-display"
      >
        Keunggulan Kirim Paket Kargo di KiriminAja
      </h2>
      <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <UiCardFeature
          v-for="(benefit, index) in benefits"
          :key="index"
          :icon="benefit.icon"
          :icon-size="benefit.iconSize"
          :title="benefit.title"
          :description="benefit.description"
        />
      </div>

      <CtaBase title="Coba Pengiriman Kargo di KiriminAja Sekarang!" />
    </UiContainer>
  </section>
</template>
